import {
    StringUtil
  } from "cartovista";
  import "../../css/searchableTreeView.css";﻿
  
      const searchViewHtml =  '<div class="searchable-treeView"><input class="cv-searchView-textBox k-textbox cv-textBox">' +
                              '<div class="cv-searchView-listBox cv-listBoxGrid k-grid k-widget k-display-block" data-role="grid"></div></div>';
  
      export default class SearchableTreeView {
        constructor(loadOnDemand, serverFiltering, serverSorting, checkboxes) {
          this._map = window.cartovista.externalInterface.map;
          this._$container = $(searchViewHtml);
          
          this._$searchInput = this._$container.find(".cv-searchView-textBox");
          this._$searchInput.on("input", _.debounce(this._refreshResults.bind(this), 250));
          this._$searchInput.keypress(_.debounce(this._onKeypress_txtSearch.bind(this), 250));
  
          this._dataSource = new kendo.data.HierarchicalDataSource({
              transport: {
                  read: this._kendoTransportRead.bind(this),
                  contentType: "application/json",
                  dataType: "json"
              },
              schema: {
                  model: {
                    hasChildren: "hasChildren",
                  }
                },
            accentFoldingFiltering: "fr-FR",//not working
              serverSorting: serverSorting,
              serverFiltering: serverFiltering,
          });
          this._listSearch = this._$container.find(".cv-searchView-listBox").kendoTreeView({
              loadOnDemand: loadOnDemand,
              checkboxes: checkboxes,
              dataSource: this._dataSource,
              template: this._rowTemplate_listSearch.bind(this),
              dataBound: this._onDataBound.bind(this),
              change: _.debounce(this._onSelect_listSearch.bind(this), 250),
              kendoKeydown: _.debounce(this._onKeypress_listSearch.bind(this), 250),
              check: _.debounce(this._onCheckChanged_listSearch.bind(this), 250),
          }).data("kendoTreeView");
        }
  
      _onKeypress_listSearch(e) {
          var keycode = (e.keyCode ? e.keyCode : e.which);
          if(keycode == '13'){
              this._listSearch.select(this._listSearch.current().parent("tr"));
          }
      };
  
      _onKeypress_txtSearch(e) {
          var keycode = (e.keyCode ? e.keyCode : e.which);
          if(keycode == '13'){
              this._onEnterKeyPressed_txtSearch();
          }
      };
  
      _onDataBound(e) {
        if(this._listSearch){
            if(this._$searchInput.val()){
                this._listSearch.expand(".k-item");
            } else{
                this._listSearch.collapse(".k-item");
            }
        }
      };
  
      _refreshResults() {
        if(this._dataSource.serverFiltering){
            setTimeout(function(){
                this._dataSource.read();//appelle la fonction _kendoTransportRead
            }.bind(this), 500);
        } else{
            var searchCriteria = this._$searchInput.val();
            this._dataSource.filter({ field: "filterText", operator: "contains", value: StringUtil.foldAccents(searchCriteria) });
        }
      };
  
      _kendoTransportRead(e) {
          throw new Error("SearchableTreeView._kendoTransportRead() not implemented.");
      };
  
      _onEnterKeyPressed_txtSearch() {
          if (this._listSearch.dataSource.data().length && this._listSearch.dataSource.data()[0].items.length === 1) {
              var item = this._listSearch.dataSource.data()[0].items[0];
              this._onSelectedItem_listSearch(item);
          }
      };
  
      _onHoveredRowIn_listSearch(e) {
          var dataItem = this._listSearch.dataItem(e.currentTarget);
          if (dataItem.layerId) this._map.getLayer(dataItem.layerId).getSimpleFeatures([dataItem.featureId], this._onHoveredRowChange_onGetFeatures, this);
      };
  
      _onHoveredRowOut_listSearch(e) {
          var dataItem = this._listSearch.dataItem(e.currentTarget);
          if(dataItem.layerId) this._map.getLayer(dataItem.layerId).rolloverFeatures = [];
      };
  
      _onHoveredRowChange_onGetFeatures(result) {
          result.layer.rolloverFeatures = result.features;
      };
  
      _onSelect_listSearch(e) {
          var selection = this._listSearch.select();
          if(selection.length == 1){
              var item = this._listSearch.dataItem(selection[0]);
              this._onSelectedItem_listSearch(item);
          }
      };

      _onSelectedItem_listSearch(dataItem){
        if(this._listSearch.options.checkboxes){
            dataItem.set("checked", !dataItem.checked);
            dataItem.set("selected", false);
            this._listSearch.trigger("check");
        } else{
            throw new Error("SearchableTreeView._onSelectedItem_listSearch() not implemented.");
        }
      }

      _onCheckChanged_listSearch(item){
        return this._getCheckedChildren(this._dataSource.data());
      }

      _getCheckedChildren(dataItems) {
        return _.compact(_.flattenDeep(_.map(dataItems, function(dataItem){
            if(dataItem.hasChildren){
                return this._getCheckedChildren(dataItem.children.data());
            } else if(dataItem.checked){
                return dataItem;
            }
        }.bind(this))));
    };

    _checkChildren(data, check){
        _.forEach(data.data(), function(dataItem){
            dataItem.set("checked", check);
            if(dataItem.hasChildren){
                this._checkChildren(dataItem.children, check);
            }
        }.bind(this));
    }
  
      _rowTemplate_listSearch(data) {
        var searchCriteria = StringUtil.foldAccents(this._$searchInput.val());
        var item = data.item;
        if(searchCriteria) {
            var match, 
                indexes = [];
            for (var regex = new RegExp(searchCriteria, "gi"); match = regex.exec(StringUtil.foldAccents(item.text));){
                indexes.push(match.index);
            }
            item.templateText = _.reduce(_.reverse(indexes), function(result, index) {
                return _.slice(result, 0, index).join("") + 
                        "<span class=cv-highlight>" + _.slice(result, index, index + searchCriteria.length).join("") + "</span>" + 
                        _.slice(result, index + searchCriteria.length, result.length).join("");
              }, item.text);

          } else {
            item.templateText = item.text;
          }
        return kendo.template(
        '# if (!item.items) { #' +
            //'<span class="k-icon k-i-close">#: item.text #</span>' +
            '#= item.templateText #' +
        '# } else { #' +
            '#= item.text #' +
        '# } #')(data);
      };
  
  }
  